import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ContactForm } from "./contact-form";
import { useSendContactRequest } from "../api/send-contact-request";

const schema = yup
    .object({
        contactName: yup.string().required("Please enter your name"),
        contactEmail: yup
            .string()
            .email("Invalid email")
            .required("Please enter your email"),
        contactReason: yup.string().required("Please select a reason"),
        contactMessage: yup
            .string()
            .required("Please describe what you need help with"),
    })
    .required();

export const UserContact = () => {
    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const { executeRecaptcha } = useGoogleReCaptcha();

    // Submit
    const mutation = useSendContactRequest();

    const sendEmail = (data) => {
        mutation.mutate({ data, executeRecaptcha });
    };

    return (
        <ContactForm
            methods={methods}
            onSubmit={sendEmail}
            isPending={mutation.isPending}
        />
    );
};
